export const networkCTN = {
  "$schema": "https://vega.github.io/schema/vega/v5.json",
  "title": {"offset": 30},
  "signals": [
    {
      "name": "width",
      "update": "(containerSize()[0] || 400)",
      "on": [{
          "events": {"source": "window", "type": "resize"},
          "update": "containerSize()[0]"
      }]
    },
    {"name": "cx", "update": "width / 2"},
    {"name": "cy", "update": "height / 2"},
    {
      "description": "State variable for active node fix status.",
      "name": "fix",
      "value": false,
      "on": [
        {
          "events": "symbol:mouseout[!event.buttons], window:mouseup",
          "update": "false"
        },
        {"events": "symbol:mouseover", "update": "fix || true"},
        {
          "events": "[symbol:mousedown, window:mouseup] > window:mousemove!",
          "update": "xy()",
          "force": true
        }
      ]
    },
    {
      "description": "Graph node most recently interacted with.",
      "name": "node",
      "value": null,
      "on": [
        {"events": "symbol:mouseover", "update": "fix === true ? item() : node"}
      ]
    }
  ],
  "data": [
    {
      "name": "node-data",
      "values": null,
      "transform": [
         {
          "type": "formula",
          "expr": null,
          "as": "origin"
        }
      ]
    },
    {
      "name": "link-data",
      "values": null
    },
    {
      "name": "origins",
      "source": "node-data",
      "transform": [
        {
          "type": "project",
          "fields": ["name", "nuts2Description"]
        },
        {
          "type": "formula",
          "expr": null,
          "as": "origin"
        }
      ]
    }
  ],
  "scales": [
    {
      "name": "color",
      "type": "ordinal",
      "domain": {"data": "link-data", "field": "sector"},
      "range": [
        "#1b9e77",
        "#d95f02",
        "#7570b3",
        "#e7298a",
        "#66a61e",
        "#e6ab02",
        "#a6761d",
        "#666666"
      ]
    },
    {
      "name": "shape",
      "type": "ordinal",
      "domain": {
        "data": "origins",
        "field": "origin"
      },
      "range": ["circle", "diamond"]
    },
    {
      "name": "shape-color",
      "type": "ordinal",
      "domain": {
        "data": "origins",
        "field": "origin"
      },
      "range": ["#333333", "#333333"]
    }
  ],
  "legends": [
    {
      "fill": "color",
      "title": null,
      "padding": 4,
      "orient": "none",
      "rowPadding": 4,
      "labelLimit": 400,
      "labelColor": "#333333",
      "titleFontSize": 14,
      "encode": {
        "legend": {
          "update": {
            "x": { "value": 0 },
            "y": {"value": 0}
          }
        },
        "symbols": {
          "enter": {
            "strokeWidth": {"value": 0.5},
            "size": {"value": 50},
            "stroke": {"value": "#999"}
          }
        },
        "labels": {
          "interactive": true,
          "update": {
            "text": {
              "signal": "datum.label === 'undefined' ? 'Companies outside Toscana' : datum.label"
            },
            "fontSize": {"value": 12}
          }
        }
      }
    },
    {
      "stroke": "shape-color",
      "orient": "none",
      "gradientLength": {"signal": "clamp(height, 64, 200)"},
      "symbolType": "circle",
      "title": null,
      "titleFontSize": 14,
      "encode": {
        "legend": {
          "update": {
            "x": { "value": 0 },
            "y": {"value": 200}
          }
        },
        "symbols": {
          "update": {
            "fill": {"value": "transparent"},
            "opacity": {"value": 0.7}
          }
        }
      },
      "shape": "shape"
    }
  ],
  "marks": [
    {
      "name": "nodes",
      "type": "symbol",
      "zindex": 1,
      "from": {"data": "node-data"},
      "on": [
        {
          "trigger": "fix",
          "modify": "node",
          "values": "fix === true ? {fx: node.x, fy: node.y} : {fx: fix[0], fy: fix[1]}"
        },
        {"trigger": "!fix", "modify": "node", "values": "{fx: null, fy: null}"}
      ],
      "encode": {
        "enter": {
          "fill": {"value": "white"},
          "stroke": {
            "value": "#333"
          },
          "strokeWidth": [
            { "test": "datum.nuts2Description === 'Toscana'", "value": 3 }, 
            { "value": 0.5 }
          ],
          "shape": {"scale": "shape", "field": "origin"}
        },
        "update": {
          "size": {"signal": "datum.edges * 7"},
          "cursor": {"value": "pointer"}
        }
      },
      "transform": [
        {
          "type": "force",
          "iterations": 300,
          "static": true,
          "signal": "force",
          "forces": [
            {"force": "center", "x": {"signal": "cx"}, "y": {"signal": "cy"}},
            {"force": "collide", "radius": 18},
            {"force": "nbody", "strength": -45},
            {"force": "link", "links": "link-data", "distance": 20}
          ]
        }
      ]
    },
    {
      "type": "path",
      "from": {"data": "link-data"},
      "interactive": false,
      "encode": {
        "update": {
          "stroke": [
            {
              "test": "fix && (datum.source.datum.name === node.datum.name || datum.target.datum.name === node.datum.name)",
              "value": "#333"
            },
            {"scale": "color", "field": "sector"}
          ],
          "strokeOpacity": [
            {
              "test": "fix && (datum.source.datum.name === node.datum.name || datum.target.datum.name === node.datum.name)",
              "value": 0.7
            },
            {"value": 0.25}
          ],
          "strokeWidth": [
            {"test": "datum.count === 1", "value": 0.5},
            {"test": "datum.count === 2", "value": 5},
            {"value": 10}
          ]
        }
      },
      "transform": [
        {
          "type": "linkpath",
          "require": {"signal": "force"},
          "shape": "line",
          "sourceX": "datum.source.x",
          "sourceY": "datum.source.y",
          "targetX": "datum.target.x",
          "targetY": "datum.target.y"
        }
      ]
    },
    {
      "type": "text",
      "zindex": 10,
      "interactive": false,
      "from": {"data": "nodes"},
      "encode": {
        "enter": {
          "dx": {"signal": "datum.edges * 4"},
          "text": {"signal": "datum.datum.nuts2Description === 'Toscana'? datum.datum.name : ''"}
        },
        "update": {
          "x": {"field": "x", "offset": 4},
          "y": {"field": "y"},
          "opacity": {
            "signal": "!fix? 1 : fix && node.datum.name === datum.datum.name? 1:0.25"
          }
        }
      }
    },
    {
      "type": "text",
      "description": "text when hovering all nodes not from Toscana",
      "zindex": 20,
      "interactive": false,
      "encode": {
        "update": {
          "text": {
            "signal": "node && node.datum.origin !== 'Toscana'? (node.datum.name + ' (' + node.datum.nuts2Description + ')') : ''"
          },
          "x": {"signal": "node? node.x : 0"},
          "y": {"signal": "node? node.y : 0"}
        }
      }
    }
  ],
  "padding": {"top": 20, "left": 15, "right": 15, "bottom": 20}
};